import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';

@Component({
  selector: 'app-mapasgeo',
  templateUrl: './mapasgeo.component.html',
  styleUrls: ['./mapasgeo.component.css'],
})

export class MapasGeoComponent implements OnInit {
  constructor(@Inject(DOCUMENT) public document: Document) { }

  ngOnInit(): void {
    // IP de Homologação
    //location.href = 'https://35.247.203.149';

    // IP de Produção
    location.href = 'http://35.198.54.17/mapasgeo';
  }
}
